import memoize from './fp/memoize';

// PARTIAL-FIX:
// For backward compatibility.
// It will be removed on version 2.0.0

export default memoize;
